export default __webpack_public_path__ + "static/media/uploading-cloud.5c469152.svg";